import { Alert, Box, Button, Stack } from "@mui/material";
import {
  loadCurrentUser,
  resendVerificationEmail,
} from "../../store/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useTranslation } from "../../translations/i18n";

const EmailVerificationBanner = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { user, loading } = useAppSelector((state) => state.auth);

  if (!user || user.email_verified) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{
        mb: 2,
        borderRadius: 2,
      }}
      action={
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
          <Button
            size="small"
            color="inherit"
            disabled={loading}
            onClick={() => dispatch(resendVerificationEmail(user.email))}
          >
            {t("auth.resendVerificationEmail")}
          </Button>

          <Button
            size="small"
            color="inherit"
            disabled={loading}
            onClick={() => dispatch(loadCurrentUser())}
          >
            {t("auth.iVerified")}
          </Button>
        </Stack>
      }
    >
      <Box>{t("auth.verifyEmailBanner")}</Box>
    </Alert>
  );
};

export default EmailVerificationBanner;
